/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlProductType } from './ControlProductType';
import {
    ControlProductTypeFromJSON,
    ControlProductTypeFromJSONTyped,
    ControlProductTypeToJSON,
} from './ControlProductType';

/**
 * 
 * @export
 * @interface ControlPaymentsFilters
 */
export interface ControlPaymentsFilters {
    /**
     * 
     * @type {ControlProductType}
     * @memberof ControlPaymentsFilters
     */
    product_type?: ControlProductType;
}

/**
 * Check if a given object implements the ControlPaymentsFilters interface.
 */
export function instanceOfControlPaymentsFilters(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaymentsFiltersFromJSON(json: any): ControlPaymentsFilters {
    return ControlPaymentsFiltersFromJSONTyped(json, false);
}

export function ControlPaymentsFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaymentsFilters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_type': !exists(json, 'product_type') ? undefined : ControlProductTypeFromJSON(json['product_type']),
    };
}

export function ControlPaymentsFiltersToJSON(value?: ControlPaymentsFilters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_type': ControlProductTypeToJSON(value.product_type),
    };
}

